import Model from "../model";
import { NormalizedModel } from "../utils/normalized/types";

export const ModelType = "PROMOTION_PROGRESS";

export default class PromotionProgress extends Model {
  // Attributes
  promotionSlug: string = "";
  criteriaType: string = "";
  currentValue: number = 0;
  requiredValue: number = 0;
  eligible: boolean = false;

  constructor(attributes: { [key: string]: any }) {
    super();
    this.addAttributes(attributes);
  }

  deserialize(input: NormalizedModel) {
    this.id = input.id;
    this.addAttributes(input.attributes);
  }
}
